import React from "react";
import {
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
} from "../Component";

function AdminPageHeader({ title, description, end }) {
  return (
    <BlockHead size="sm">
      <BlockBetween>
        <BlockHeadContent>
          <BlockTitle tag="h3" page>
            {title}
          </BlockTitle>
          {description ? (
            <BlockDes className="text-soft">
              {typeof description === "string" ? <p className="mb-0">{description}</p> : description}
            </BlockDes>
          ) : null}
        </BlockHeadContent>
        {end ? <BlockHeadContent>{end}</BlockHeadContent> : null}
      </BlockBetween>
    </BlockHead>
  );
}

export default AdminPageHeader;
